import dva from 'dva';
import models from './models';
import router from './router';

import 'antd/dist/antd.less';
import './index.less';

// 1. Initialize
const app = dva();

// 2. Plugins

// 3. Model
(models || []).forEach((model) => app.model(model));
// app.model();

// 4. Router
app.router(router);

// 5. Start
app.start('#root');
